import { NavLink, Outlet, useNavigate } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';
import { cn } from '@/lib/utils';

const ITENS = [
  { para: '/minha-conta', rotulo: 'Visão geral', fim: true },
  { para: '/minha-conta/eventos', rotulo: 'Meus eventos' },
  { para: '/minha-conta/assinatura', rotulo: 'Lily Pass' },
  { para: '/minha-conta/pedidos', rotulo: 'Pedidos' },
  { para: '/minha-conta/dados', rotulo: 'Dados e senha' },
];

export default function MinhaContaLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const primeiroNome = user?.name?.split(' ')[0];

  const sair = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="bg-paper min-h-[calc(100vh-4.5rem)]">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14">
        <header className="mb-8">
          <p className="text-wine text-xs font-semibold tracking-[0.18em] uppercase">
            Minha conta
          </p>
          <h1 className="font-display text-ink mt-2 text-3xl sm:text-[2.5rem]">
            {primeiroNome ? `Olá, ${primeiroNome}` : 'Olá'}
          </h1>
        </header>

        <div className="grid gap-8 lg:grid-cols-[13rem_1fr] lg:gap-12">
          <nav
            aria-label="Seções da conta"
            className="hide-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 lg:mx-0 lg:flex-col lg:gap-1 lg:overflow-visible lg:px-0"
          >
            {ITENS.map((item) => (
              <NavLink
                key={item.para}
                to={item.para}
                end={item.fim}
                className={({ isActive }) =>
                  cn(
                    'shrink-0 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors lg:shrink',
                    isActive
                      ? 'bg-petal text-ink-soft'
                      : 'text-ink-soft/70 hover:bg-paper-warm hover:text-wine',
                  )
                }
              >
                {item.rotulo}
              </NavLink>
            ))}

            <button
              type="button"
              onClick={sair}
              className="text-ink-soft/50 hover:text-wine shrink-0 rounded-xl px-4 py-2.5 text-left text-sm font-medium transition-colors lg:mt-4 lg:shrink"
            >
              Sair
            </button>
          </nav>

          <main className="min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
